import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M480-346q-8 0-15-4-7-3-13-9L254-556q-12-12-11-29t12-28q12-12 29-12t28 12l168 169 169-169q12-12 28-11t28 12q12 12 12 29t-12 28L508-359q-6 6-13 9-7 4-15 4Z"/>',
  f: '<path d="M480-346q-8 0-15-4-7-3-13-9L254-556q-12-12-11-29t12-28q12-12 29-12t28 12l168 169 169-169q12-12 28-11t28 12q12 12 12 29t-12 28L508-359q-6 6-13 9-7 4-15 4Z"/>',
};

export default data;
